import {ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {PaginationUIService} from '@services/paginationUI.service';

@Component({
    selector: 'app-paging-control',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        PaginationUIService
    ],
    template: `
        <g-row>
            <g-col [paddingRight]="0">
                <button class="button button--icon" style="font-size: 15px" type="button" [disabled]="page <= 1" (click)="prev()">
                    ←
                </button>
            </g-col>
            <g-col>
                <button class="button" style="font-size: 15px" type="button" [disabled]="page >= pagesTotal" (click)="next()">
                    Далее →
                </button>
            </g-col>
            <g-col [grow]="true"></g-col>
            <g-col [paddingLeft]="0" *ngFor="let item of pagesButtons">
                <button class="button button--icon button--pagination"
                        [class.button--pagination-active]="item.page === page" type="button"
                        (click)="onPageClick(item.page)">{{item.title}}</button>
            </g-col>
        </g-row>
    `
})

export class PagingControlComponent implements OnChanges {
    @Input() pagesTotal = 1;
    @Input() page = 1;

    @Output() pageChange = new EventEmitter<number>();

    public pagesButtons: PagingButton[] = [];

    private maxVisiblePages = 9;

    constructor(
        private paginationUiService: PaginationUIService,
        private cd: ChangeDetectorRef,
    ) {}

    ngOnChanges() {
        this.calculateButtons();
    }

    prev() {
        if (this.page > 1) {
            this.page--;
            this.emitPageChose();
            this.calculateButtons();
            this.cd.detectChanges();
        }
    }

    next() {
        if (this.page < this.pagesTotal) {
            this.page++;
            this.emitPageChose();
            this.calculateButtons();
            this.cd.detectChanges();
        }
    }

    onPageClick(page: number) {
        if (page === this.page) {
            return;
        }
        this.page = page;
        this.emitPageChose();
        this.calculateButtons();
        this.cd.detectChanges();
    }

    private calculateButtons() {
        this.pagesButtons = this.paginationUiService.getPagesLinks(this.pagesTotal, this.page, this.maxVisiblePages);
    }

    private emitPageChose() {
        this.pageChange.emit(this.page);
    }
}

interface PagingButton {
    title: string|number;
    page: number;
}
